import {Component, OnInit} from '@angular/core';
import {LoanApplicationProgress, LoanApplicationProgressFactory, ProgressMilestones} from './loan-application-progress.factory';
import {LoanApplicationService} from '../../service/loan-application.service';
import {ActivatedRoute} from '@angular/router';
import {LoanApplicationPipelineStage} from '../../model/LoanApplicationTransition';

interface ProgressDescription {
    heading: string;
    subheading: string;
    description: string;
}

@Component({
    selector: 'app-application-status',
    templateUrl: './application-status.component.html',
    styleUrls: ['./application-status.component.css']
})
export class ApplicationStatusComponent implements OnInit {
    public ProgressMilestones = ProgressMilestones;
    public applicationProgress: LoanApplicationProgress;
    public progressDescription: ProgressDescription;

    constructor(private progressMapper: LoanApplicationProgressFactory,
                private loanApplicationService: LoanApplicationService, private route: ActivatedRoute) {
    }

    async ngOnInit(): Promise<void> {
        this.applicationProgress = this.progressMapper.getUpdatedProgress();

        const loanApplicationId = this.route.snapshot.params.id;
        let latestTransition = null;
        try {
            latestTransition = await this.loanApplicationService.getLatestTransition(loanApplicationId);
        } catch (error) {
            latestTransition = null;
        }
        if (!latestTransition) {
            const cloningRequest = await this.loanApplicationService.getLoanApplicationCloningRequestByClonedLoanApplicationId(loanApplicationId);
            if (cloningRequest && cloningRequest.consentRequired) {
                this.progressDescription = this.getProgressDescription(LoanApplicationPipelineStage.Verification);
            }
        } else {
            this.progressDescription = this.getProgressDescription(latestTransition.toStage);
        }
        this.applicationProgress = this.progressMapper.getUpdatedProgress(latestTransition.toStage);
    }

    getProgressDescription(currentStage: LoanApplicationPipelineStage) {
        switch (currentStage) {
            case LoanApplicationPipelineStage.Verification:
                return {
                    heading: 'Thank you for submitting your application!',
                    subheading: 'Your application is being processed',
                    description: 'The review of the KYC documents you submitted is in progress.'
                };

            case  LoanApplicationPipelineStage.Sanction:
            case  LoanApplicationPipelineStage.PreCreditAssessment:
            case  LoanApplicationPipelineStage.DetailedCreditAssessment:
                return {
                    heading: 'Your KYC is verified successfully!',
                    subheading: 'Our credit assessment team will pick up your application for credit analysis',
                    description: 'We would ensure that we offer you the best rate of interest customised for you.'
                };
        }
    }
}
